import { render, staticRenderFns } from "./ProcessedTickets.vue?vue&type=template&id=38739af8&scoped=true&"
import script from "./ProcessedTickets.vue?vue&type=script&lang=js&"
export * from "./ProcessedTickets.vue?vue&type=script&lang=js&"
import style0 from "./ProcessedTickets.vue?vue&type=style&index=0&id=38739af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38739af8",
  null
  
)

export default component.exports